import {
    AuthenticationService,
    ImageGallerieComponent,
    ImageUploadCompositionComponent,
    News,
    Nl2brPipe,
    NotificationService,
} from 'kkm-library';
import {FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Component, input, model, inject, output} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NewsService} from 'src/app/modules/news/news.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {DatePipe} from '@angular/common';
import {LinkyModule} from 'ngx-linky';

@Component({
    selector: 'kkm-news-card-large',
    templateUrl: './news-card-large.component.html',
    styleUrls: ['./news-card-large.component.scss'],
    imports: [
        MatCardModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        TextFieldModule,
        MatCheckboxModule,
        ImageGallerieComponent,
        DatePipe,
        LinkyModule,
        Nl2brPipe,
        ImageUploadCompositionComponent,
    ],
})
export class NewsCardLargeComponent {
    private newsService = inject(NewsService);
    public authService = inject(AuthenticationService);
    private notification = inject(NotificationService);

    news = model<News>();

    showButtons = input(false);
    newsChange = output<boolean>();

    showEditForm = false;
    showImageUpload = false;

    newsForm = new FormGroup({
        id: new FormControl<number>(0, {nonNullable: true}),
        betreff: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
        beschreibung: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
        freigegeben: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
    });

    abbrechen(): void {
        this.showEditForm = false;
        this.newsChange.emit(false);
    }

    speichern(): void {
        if (!this.newsForm.valid) {
            this.notification.error('Es sind nicht alle Felder ausgefüllt');
            return;
        }

        const newNews = Object.assign(this.newsService.newNews(), this.newsForm.value);
        this.newsService.speichern(newNews);
        this.news.set(newNews);

        console.log(this.news());

        this.showEditForm = false;
        this.newsChange.emit(true);
    }

    editEntry(): void {
        if (this.news()) {
            this.newsForm.patchValue(this.news()!);
        }
        this.showEditForm = true;
    }

    deleteEntry(): void {
        if (this.news() && this.news()?.id) {
            this.newsService.delete(this.news()!);
            this.newsChange.emit(true);
        }
    }
}
